// removed by extract-text-webpack-plugin
module.exports = {"text":"text__1zVEw","center":"center__3xHGi","tight":"tight__2wRTV","flush":"flush__2svUH"};


//////////////////
// WEBPACK FOOTER
// ./components/ChartTitle/style.css
// module id = J/c/
// module chunks = 0